import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth/autoContext';
import type { UserProfile } from '../Data/typeusers';
import { toast } from 'react-toastify';
import { cancelPayPalSubscription, getCurrentUser } from "../Data/dataApi";
import '../Css/profile.css';
import { Helmet } from 'react-helmet-async';

const Profile: React.FC = () => {

    const { t } = useTranslation();

    const navigate = useNavigate();

    const { role, setRole } = useAuth();

    const [user, setUser] = useState<UserProfile | null>(null);

    useEffect(() => {

        const storedUser = sessionStorage.getItem('user');

        if (storedUser) {

            setUser(JSON.parse(storedUser));
        }

    }, []);

    const handleCancelSubscription = async () => {

        const confirmCancel = window.confirm(
            t('profile.confirmCancel')
        );

        if (!confirmCancel) return;

        try {

            if (!user?.id) {
                toast.error("Utilisateur introuvable");
                return;
            }

            await cancelPayPalSubscription({
                userId: user.id
            });

            // 🔥 refresh user role depuis backend
            const updatedUser = await getCurrentUser();

            sessionStorage.setItem('user', JSON.stringify(updatedUser));
            setUser(updatedUser);
            console.log("UPDATED USER:", updatedUser);
            // 🔥 synchroniser le role global
            setRole(updatedUser.role);

            toast.success(t('profile.subscriptionCancelled'));

        } catch (error) {

            console.error(error);

            toast.error(t('profile.cancelError'));
        }
    };

    return (
        <>
            <Helmet>
                <title>
                    Profil | Stockifly
                </title>

                <meta
                    name="description"
                    content="Profil Stockifly"
                />
            </Helmet>

            <div className="profile-page">

                <div className="profile-card">

                    <h1>
                        {t('profile.title')}
                    </h1>

                    <div className="profile-section">

                        <label>
                            {t('profile.firstname')}
                        </label>

                        <p>
                            {user?.firstName}
                        </p>

                    </div>

                    <div className="profile-section">

                        <label>
                            {t('profile.lastname')}
                        </label>

                        <p>
                            {user?.lastName}
                        </p>

                    </div>

                    <div className="profile-section">

                        <label>
                            {t('profile.email')}
                        </label>

                        <p id="email-value">
                            {user?.userName}
                        </p>

                    </div>

                    <div className="profile-section">

                        <label>
                            {t('profile.plan')}
                        </label>

                        <div className="plan-row">

                            <p
                                className={
                                    role === 'premium'
                                        ? 'premium-plan'
                                        : 'free-plan'
                                }
                            >
                                {role}
                            </p>

                            {role === 'premium' && (

                                <button
                                    className="cancel-plan-btn"
                                    onClick={handleCancelSubscription}
                                >
                                    {t('profile.cancelSubscription')}
                                </button>
                            )}

                        </div>

                    </div>

                    {role !== 'premium' && (

                        <button
                            className="upgrade-btn"
                            onClick={() => navigate('/upgradePremium')}
                        >
                            {t('profile.upgrade')}
                        </button>
                    )}

                </div>

            </div>
        </>
    );
};

export default Profile;